import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerInsuranceComponent } from './customer-insurance.component';

@NgModule({
    declarations: [
        CustomerInsuranceComponent,
    ],
    providers: [],
    imports: [
        CommonModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        CustomerInsuranceComponent,
    ]
})

export class CustomerInsuranceModule { }
